import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const JoinPropertyApi = {
    post: (propertyUuid) => {
        return fetch(
            BASE_API_URL + '/api/user-property-charging-requests',
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ propertyUUID: propertyUuid }),
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
}